import { AddressInputs } from "Components/AddressInputs";
import { AsteriskNotification } from "Components/AsteriskNotification";
import { BulmaNavButtons } from "Components/BulmaNavButtons";
import { useDocumentTitle } from "Components/Hooks";
import { Horizontal } from "Components/Horizontal";
import { PhoneInput } from "Inputs/PhoneInput";
import { RadioYesNo } from "Inputs/Radio";
import { EmailInput, Textbox } from "Inputs/Textbox";
import { Program } from "SharedConstants";
import { FitnessInstructorApplicantInfoModel } from "SharedConstants/Schema";
import { toObject } from "Tools";
import { TypeOfOperationInput } from "Views/Shared/TypeOfOperationInput";
import { Heading } from "../../../Components/Heading";
import { MVCForm, MVCFormServerProps } from "../../MVCForm";
import { ModelStateValues } from "../../Tools";
import { InstructorTypeSection } from "./InstructorTypeSection";

export function ApplicantInformation(
  props: FitnessInstructorApplicantInfoModel & {
    formProps: MVCFormServerProps;
  },
) {
  const getInitialValues = (values: ModelStateValues) => {
    return {
      ...toObject(
        props.ProfessionList.filter(profession =>
          props.ProfessionsSelected.includes(profession.DisplayName),
        ).map(e => [`Profession_${e.ProfessionID}`, true]),
      ),
      ...values,
      ConfirmEmailAddress: values.EmailAddress,
      OtherInstructorCheckbox:
        !!values.OtherInstructorType || values.OtherInstructorCheckbox,
    };
  };
  const title = "Applicant Information";
  useDocumentTitle(`${title} - ${props.TitleProps.PageTitleSuffix}`);
  return (
    <>
      <Heading
        {...props}
        title={`${props.IsRenewal ? "Renewal " : ""}${title}`}
      />
      <MVCForm
        {...props.formProps}
        initialValues={getInitialValues(props.formProps.initialValues)}
      >
        {({ values, isSubmitting }) => (
          <>
            <AsteriskNotification />
            <Horizontal isRequired label="Instructor">
              <Textbox fieldName="FirstName" placeholder="First Name" />
              <Textbox fieldName="LastName" placeholder="Last Name" />
            </Horizontal>
            {props.Program === Program.PersonalTrainer && (
              <TypeOfOperationInput
                TypeOfOperationModel={values.TypeOfOperationModel}
              />
            )}
            <Horizontal isRequired label="Instructor Age" shouldNotPadLabel>
              <RadioYesNo fieldName="WillInstructorBeOfAge">
                <div className="has-text-weight-bold">
                  Will the instructor be at least 18 years old when the policy
                  becomes effective?
                </div>
              </RadioYesNo>
            </Horizontal>
            <InstructorTypeSection {...props} />
            <Horizontal isRequired label="Contact">
              <Textbox fieldName="ContactFirstName" placeholder="First Name" />
              <Textbox fieldName="ContactLastName" placeholder="Last Name" />
            </Horizontal>
            <Horizontal isRequired label="Phone">
              <PhoneInput fieldName="PhoneNumber1" />
            </Horizontal>
            <Horizontal isRequired label="Contact Email">
              <EmailInput
                fieldName="EmailAddress"
                placeholder="name@company.com"
              />
            </Horizontal>
            <Horizontal isRequired label="Confirm Email">
              <EmailInput
                fieldName="ConfirmEmailAddress"
                placeholder="name@company.com"
              />
            </Horizontal>
            <AddressInputs isRequired label="Mailing Address" />
            <BulmaNavButtons
              backCaption={props.BackButtonText}
              continueCaption="Continue"
              isDisabled={isSubmitting}
            />
          </>
        )}
      </MVCForm>
      {props.AgentName && (
        <p
          className="has-text-centered has-text-weight-bold"
          style={{ marginTop: "1em" }}
        >
          Agent: {props.AgentName}
        </p>
      )}
    </>
  );
}
